import React from 'react';
import BilanIconButton from './BilanIconButton';

interface isPdfFileButtonProps {
  onClick?: (
    ev:
      | React.MouseEvent<HTMLAnchorElement, MouseEvent>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => void;
}

export default function PdfFileButton({ onClick }: isPdfFileButtonProps) {
  return (
    <BilanIconButton
      aria-label="Ouvrir le bilan PDF"
      iconType="file_pdf"
      onClick={onClick}
      size="xs"
      variantType="primary"
    />
  );
}
